export default __webpack_public_path__ + "static/media/navbar-sent-dark.40e02619.svg";